const STORAGE_KEY = 'lieu';
const ATTRIBUTE_NAME = 'data-lieu';
const PLURAL = 'plural';

export { STORAGE_KEY, ATTRIBUTE_NAME, PLURAL };
